import { useDispatch, useSelector } from "react-redux";
import { closeDeleteBoxPopup, deleteShipmentBox, selectDeleteBoxPopup, selectShipmentBoxDeletingStatus } from "../ShipmentItems/shipmentItemsSlice";
import Popup from "../../../components/Popup";
import { Button } from "@mui/material";
import RedSpinner from "../../../components/loaders/RedSpinner";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const DeleteBoxPopup = () => {
    const {t} = useTranslation();
  const dispatch = useDispatch();
  const popupState = useSelector(selectDeleteBoxPopup);
  const deletingStatus = useSelector(selectShipmentBoxDeletingStatus);
  
  const closePopup = () => {
      dispatch(closeDeleteBoxPopup());
  }

  const handleDeleteButtonClick = () => {
      if (!popupState.shipmentID) {
          return
      }
      dispatch(deleteShipmentBox({ shipmentID: popupState.shipmentID, boxID: popupState.boxID }));
  }

  useEffect(() => {
        if (deletingStatus === "fulfilled") {
            dispatch(closeDeleteBoxPopup());
        }
    }, [deletingStatus, dispatch])


  return (
      <Popup opened={popupState.opened} closeCallback={closePopup}>
          <div style={{
              height: "10vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
          }}>
              <Button
                      variant="contained"
                      sx={{
                          color: "white",
                          bgcolor: "#dc2626",
                          fontSize: "0.8rem",
                          ":hover": {
                              bgcolor: "#b91c1c",
                          },
                      }}
                      onClick={handleDeleteButtonClick}
                  >
                      {t("shipment.items.delete_box_button")} 
                      {deletingStatus === "pending" && 
                          <span className="">
                              <RedSpinner width={20} height={20}/>
                          </span>}
                  </Button>
          </div>
      </Popup>
)
}

export default DeleteBoxPopup